<ng-container *transloco="let t">
  <button iButton [iDropdownMenuTrigger]="keywordMenu" variant="ghost" appNavBreadcrumb>
    {{ (searchTerm$ | async)?.searchTerm }}
    <IIcon name="chevronDown" />
  </button>

  <ng-template #keywordMenu>
    <IDropdownMenu>
      @for (keyword of keywordTrackerData(); track keyword.searchTerm) {
        <button iDropdownMenuItem (click)="navigateToSearchTerm(keyword)">
          {{ keyword.searchTerm }}
        </button>
      }
    </IDropdownMenu>
  </ng-template>
  <div class="flex h-full flex-col gap-2">
    @if (addProductMessage$ | async; as m) {
      <IAlert type="info" [title]="m.message" />
    }
    <IAlert type="info" [title]="t('keyword-tracker-details.display_only_first_search')" />
    <div class="flex-1 shrink-0">
      <app-keyword-tracking-timeline />
    </div>
  </div>
</ng-container>
